import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, booleanAttribute } from '@angular/core';

@Component({
  selector: 'ui-toggle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      type="button"
      role="switch"
      [attr.aria-checked]="checked"
      [attr.aria-label]="ariaLabel"
      [disabled]="disabled"
      (click)="onToggle()"
      [class]="trackClasses()"
    >
      <span [class]="thumbClasses()"></span>
    </button>
  `,
})
export class UiToggleComponent {
  @Input({ transform: booleanAttribute }) checked = false;
  @Input({ transform: booleanAttribute }) disabled = false;
  @Input() ariaLabel?: string;
  @Input() toggleClass = '';
  @Input() thumbClass = '';

  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle(): void {
    if (this.disabled) return;
    this.checkedChange.emit(!this.checked);
  }

  trackClasses(): string {
    return [
      'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full',
      'transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      this.checked ? 'bg-blue-600' : 'bg-gray-200',
      this.toggleClass,
    ].filter(Boolean).join(' ');
  }

  thumbClasses(): string {
    return [
      'inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200',
      this.checked ? 'translate-x-6' : 'translate-x-1',
      this.thumbClass,
    ].filter(Boolean).join(' ');
  }
}
